import { createContext, useContext, useMemo } from "react";

const EditSearchContext = createContext("");

export const EditSearchProvider = ({ value, children }) => (
  <EditSearchContext.Provider value={value || ""}>
    {children}
  </EditSearchContext.Provider>
);

export const useEditSearch = () => useContext(EditSearchContext);

const matches = (search, terms) => {
  if (!search) return true;
  const q = search.toLowerCase().trim();
  if (!q) return true;
  return terms.some(
    (t) => typeof t === "string" && t.toLowerCase().includes(q),
  );
};

export const SearchableField = ({ label, name, keywords, children }) => {
  const search = useEditSearch();
  const visible = matches(search, [label, name, keywords]);
  if (!visible) return null;
  return children;
};

export const SearchableSection = ({
  title,
  labels = [],
  keywords,
  children,
}) => {
  const search = useEditSearch();
  const allTerms = useMemo(
    () => [title, keywords, ...labels],
    [title, keywords, labels],
  );
  if (!matches(search, allTerms)) return null;
  return children;
};
